<template>
  <div class="bg-gray-100 py-6" style="height:calc(100vh - 70px)">
    <div class="bg-white overflow-hidden shadow rounded-lg max-w-4xl mx-auto">
      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
        <div
          class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap"
        >
          <div class="ml-4 mt-2">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Campaigns
            </h3>
          </div>
          <div class="ml-4 mt-2 flex-shrink-0">
            <span class="inline-flex rounded-md shadow-sm">
              <!-- <button
                type="button"
                class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                @click="createNew()"
              >
                Create new
              </button> -->
            </span>
          </div>
        </div>
      </div>
      <div>
        <!-- Content goes here -->
        <ul>
          <li v-for="(campaign, index) of campaigns" :key="index">
            <a
              @click="gotoCampaignDetail(campaign)"
              class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out cursor-pointer"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="grid grid-cols-7">
                  <div
                    class="text-sm leading-5 font-medium text-indigo-600 truncate col-span-2"
                  >
                    {{ campaign.name }}
                  </div>

                  <div
                    class="col-span-3 text-gray-700 text-sm whitespace-pre-wrap"
                  ></div>
                </div>
              </div>
            </a>
          </li>
          <li
            class="text-center text-gray-700 text-sm p-20"
            v-if="templates.length === 0"
          >
            Create a template to start sending marketing messages
          </li>
          <li
            class="text-center text-gray-700 text-sm p-20"
            v-if="templates.length > 0 && campaigns.length === 0"
          >
            Create a campaign to start sending marketing messages
          </li>
        </ul>
      </div>
    </div>

    <CreateCampaign v-if="showModal" @close="closeModal" @create="onCreate" />
  </div>
</template>

<script>
import CreateCampaign from "@/components/Marketing/CreateCampaign.vue";

export default {
  name: "Campaigns",
  components: {
    CreateCampaign
  },
  data() {
    return {
      showModal: false,
      currentTemplate: null
    };
  },
  computed: {
    templates() {
      return this.$store.getters["Marketing/getTemplates"];
    },
    campaigns() {
      return this.$store.getters["Marketing/getCampaigns"];
    }
  },
  created() {
    this.loadTemplates();
    this.loadCampaigns();
  },
  methods: {
    loadTemplates() {
      this.$store.dispatch("Marketing/getTemplates");
    },
    loadCampaigns() {
      this.$store.dispatch("Marketing/getCampaigns");
    },
    closeModal() {
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    createNew() {
      this.currentTemplate = null;
      this.openModal();
    },
    onCreate() {
      this.loadCampaigns();
      this.closeModal();
    },

    gotoCampaignDetail(campaign) {
      this.$router.push({
        name: "CampaignDetail",
        params: { campaignId: campaign.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
